import { render, staticRenderFns } from "./VGroup.vue?vue&type=template&id=ff3b52d8&"
import script from "./VGroup.vue?vue&type=script&lang=js&"
export * from "./VGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports